<template>
  <router-view />
</template>

<script>
  export default {
    name: 'test'

  };
</script>

<style></style> 